import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["className", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useContext, useMemo, useState } from 'react';
import Collapse from 'react-bootstrap/Collapse';
var CollapseContext = createContext({
  toggled: false,
  id: '',
  setToggled: function setToggled() {}
});
function useCollapseContext() {
  var context = useContext(CollapseContext);
  if (!context) {
    throw new Error('Child components of Collapse cannot be rendered outside the Collapse component!');
  }
  return context;
}
export var CollapseECS = function CollapseECS(_ref) {
  var children = _ref.children,
    id = _ref.id,
    defaultToggle = _ref.defaultToggle;
  var _useState = useState(defaultToggle || false),
    _useState2 = _slicedToArray(_useState, 2),
    toggled = _useState2[0],
    setToggled = _useState2[1];
  var value = useMemo(function () {
    return {
      id: id,
      toggled: toggled,
      setToggled: setToggled
    };
  }, [id, toggled]);
  return React.createElement(CollapseContext.Provider, {
    value: value
  }, children);
};
export var CollapseECSButton = function CollapseECSButton(_ref2) {
  var className = _ref2.className,
    children = _ref2.children,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var _useCollapseContext = useCollapseContext(),
    id = _useCollapseContext.id,
    toggled = _useCollapseContext.toggled,
    setToggled = _useCollapseContext.setToggled;
  var clName = className || '';
  return React.createElement("button", _objectSpread(_objectSpread({}, restProps), {}, {
    className: "".concat(toggled ? 'collapse-open' : 'collapse-closed', " ").concat(clName, " btn"),
    onClick: function onClick(e) {
      if (restProps.onClick) {
        restProps.onClick(e);
      }
      setToggled(!toggled);
    },
    type: "button",
    "aria-controls": id,
    "aria-expanded": toggled
  }), children);
};
export var CollapseECSBody = function CollapseECSBody(_ref3) {
  var className = _ref3.className,
    children = _ref3.children;
  var _useCollapseContext2 = useCollapseContext(),
    id = _useCollapseContext2.id,
    toggled = _useCollapseContext2.toggled;
  return React.createElement("div", {
    id: id
  }, React.createElement(Collapse, {
    "in": toggled,
    className: className
  }, React.createElement("div", null, children)));
};